import dayjs from 'dayjs';

export function formatReviewDate(dateStr) {
    return dayjs(dateStr).format('MMMM DD. YYYY');
}
